import React, {useMemo} from "react";
import {DatePicker, message,} from "antd";
import {useTranslation} from "react-i18next";
import {SearchInput} from "../../molecules/searchInput/SearchInput";
import {useSearchParams} from "react-router-dom";
import {removeExistingParamsArrayValue} from "../../../common/fns";
import {IGetPlanLongAPIParam} from "../../../api/apiTypes";
import dayjs, {Dayjs} from "dayjs";
import {DATE_FORMAT} from "../../../common/consts.common";

export interface Props {
  params: IGetPlanLongAPIParam
  onSearch?: (params: IGetPlanLongAPIParam) => void;
}

export const PlanFilter = ({
                             params, onSearch,
                           }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [messageApi, messageHolder] = message.useMessage();
  const {t} = useTranslation("shipping");
  const ddat = useMemo(() => {
    if (Array.isArray(params.plan_date)) {
      return dayjs(params.plan_date[0], DATE_FORMAT)
    }
    return dayjs();
  }, [params])
  
  const handleFilterCluster = (value: string) => {
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "cluster_id__startswith", value), cluster_id__startswith: value
    }));
  }
  
  const handleFilterDate = (date: Dayjs, dateString: string[] | string) => {
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "plan_date", dateString), plan_date: dateString
    }));
  };
  
  const handleFilterByRound = (selectedOption: string | number) => {
    setSearchParams({
      ...removeExistingParamsArrayValue(searchParams, 'plan_no', selectedOption), plan_no: selectedOption
    })
  };
  
  return (<>
    {messageHolder}
    <div style={{marginRight: 8}} className={"text-base"}>검색 입력</div>
    <SearchInput
      placeholder={t("cluster_id")}
      maxLength={16}
      inputMode="numeric"
      value={params.cluster_id__startswith}
      onSearch={handleFilterCluster}
      suffixType={"search"}
    />
    <DatePicker
      size={"small"}
      value={ddat}
      format={DATE_FORMAT}
      placeholder={t("plan date")}
      onChange={handleFilterDate}
    />
    <SearchInput
      placeholder={t("Filter by plan no")}
      maxLength={3}
      inputMode="numeric"
      value={params.plan_no ? params.plan_no + "" : undefined}
      onSearch={handleFilterByRound}
      suffixType={"clear"}
    />
  </>);
};